import { useDispatch } from 'react-redux';
import { showSnackbar } from '../Reducer/SnackbarReducer';
import { Capacitor } from '@capacitor/core';
import { AppLauncher } from '@capacitor/app-launcher';

/**
 * 📞 usePhoneCall 훅
 *
 * - Android: AppLauncher → 네이티브 다이얼러 실행 (AI 전화앱 호환)
 * - iOS / Web: tel: 스킴 fallback
 * - 실패 시: 전화번호 클립보드 복사 + Snackbar 알림
 */
export default function usePhoneCall() {
  const dispatch = useDispatch();

  const copyPhoneNumber = (phoneNumber) => {
    if (!phoneNumber) return;
    navigator.clipboard.writeText(phoneNumber);
    dispatch(
      showSnackbar({
        message: `전화번호가 복사되었습니다.`,
        type: 'success',
      })
    );
  };

  const fallbackCall = (phoneNumber) => {
    try {
      window.open(`tel:${phoneNumber}`, '_system');
    } catch (e) {
      console.error('📞 fallbackCall 실패:', e);
      copyPhoneNumber(phoneNumber);
    }
  };

  const handleCall = async (phoneNumber) => {
    if (!phoneNumber) {
      dispatch(
        showSnackbar({
          message: '전화번호가 등록되지 않았습니다.',
          type: 'warning',
        })
      );
      return;
    }

    if (Capacitor.isNativePlatform()) {
      try {
        const { value } = await AppLauncher.canOpenUrl({
          url: `tel:${phoneNumber}`,
        });

        if (value) {
          await AppLauncher.openUrl({ url: `tel:${phoneNumber}` });
          return;
        } else {
          console.warn('⚠️ 전화 앱이 Intent를 처리하지 못함');
          copyPhoneNumber(phoneNumber);
        }
      } catch (err) {
        console.error('📞 AppLauncher 전화 호출 실패:', err);
        copyPhoneNumber(phoneNumber);
      }
      return;
    }

    const isAndroid = /Android/i.test(navigator.userAgent);
    if (isAndroid) {
      try {
        window.location.href = `tel:${phoneNumber}`;
      } catch (e) {
        console.error('📱 Android WebView 전화 실패:', e);
        fallbackCall(phoneNumber);
      }
    } else {
      fallbackCall(phoneNumber);
    }
  };

  return { handleCall, copyPhoneNumber };
}
